import React, { useState, useEffect, useCallback } from 'react';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng = s => String(s).replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const numFmt = n => n ? Number(n).toLocaleString('fa-IR') : '•';
const si = v => { try{return parseInt(toEng(String(v||0)),10)||0;}catch{return 0;} };

/* فراخوانی API + رفرش توکن */
async function API(path, opts={}){
  const doFetch=()=>fetch(`/api/accounting${path}`,{
    headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts});
  let res=await doFetch();
  if(res.status===401){
    const rr=await fetch('/api/auth/token/refresh/',{method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({refresh:localStorage.getItem('refresh')})});
    if(rr.ok){const d=await rr.json();localStorage.setItem('access',d.access);res=await doFetch();}
  }
  return res.json();
}

/* سپرده */
export default function DepositReadyModal({ year, onClose, onAdded }) {
  const [mode,      setMode]      = useState('credit'); // credit | refund
  const [month,     setMonth]     = useState('1');
  const [rows,      setRows]      = useState([]);
  const [checked,   setChecked]   = useState({});
  const [sel2,      setSel2]      = useState({}); // فقط برای refund — «ثبت پرداخت بانکی هم»
  const [bankCode,  setBankCode]  = useState('');
  const [bankNo,    setBankNo]    = useState('');

  // سند مقصد
  const [readyNo,   setReadyNo]   = useState('');   // خالی = سند جدید
  const [docDate,   setDocDate]   = useState('');

  const [loading,   setLoading]   = useState(false);
  const [saving,    setSaving]    = useState(false);
  const [error,     setError]     = useState('');
  const [toast,     setToast]     = useState('');
  const [serverTotal,   setServerTotal]   = useState(0);
  const [serverHasMore, setServerHasMore] = useState(false);
  const [loadingMore,   setLoadingMore]   = useState(false);
  const [currentPage,   setCurrentPage]   = useState(1);

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),4000); };

  // عرض ستون‌ها — بسته به حالت
  const creditRz = useColumnResize([40,110,55,80,120,90,150,180,140]);
  const refundRz = useColumnResize([40,110,120,120,110,120,110,110,180,140]);
  const rz = mode==='credit' ? creditRz : refundRz;
  const TH = rz.TH;

  useEffect(() => {
    API(`/documents/next-no/?year=${year}`).then(j => {
      if (j.ok) { setDocDate(j.last_date || ''); }
    });
  }, [year]);

  /* خواندن فهرست از سرور */
  const load = useCallback(async () => {
    setLoading(true); setError(''); setRows([]); setChecked({}); setSel2({}); setCurrentPage(1);
    const j = await API(`/auto-document/deposit/ready/?mode=${mode}&year=${year}&month=${si(month)||1}`);
    setLoading(false);
    if (j.ok) {
      setRows(j.data); setServerTotal(j.total||j.count||0); setServerHasMore(j.has_more||false);
      if (mode === 'refund') {
        const s2 = {};
        j.data.forEach((r,i) => { s2[i] = true; });
        setSel2(s2);
      }
    } else setError(j.msg);
  }, [mode, month, year]);

  /* ۲۰۰ ردیف بعدی */
  const loadMore = async () => {
    const nextPage = currentPage + 1;
    setLoadingMore(true);
    const j = await API(`/auto-document/deposit/ready/?mode=${mode}&year=${year}&month=${si(month)||1}&page=${nextPage}`);
    setLoadingMore(false);
    if (j.ok) {
      setRows(prev => [...prev, ...j.data]);
      setServerTotal(j.total||0); setServerHasMore(j.has_more||false); setCurrentPage(nextPage);
    }
  };

  useEffect(() => { load(); }, [load]);

  const keyOf = r => mode==='credit'
    ? `${r.credit_no}-${r.credit_year}-${r.detail_row}`
    : `${r.refund_detail_id}`;

  const toggleAll = (val) => {
    const next = {};
    rows.forEach((r,i) => { next[i] = val; });
    setChecked(next);
  };

  const selectedRows = rows.filter((_,i) => checked[i]);
  const totalAmount = selectedRows.reduce((s,r) =>
    s + (mode==='credit' ? si(r.detail_amount) : si(r.refund_pay)), 0);

  const isNewDoc = si(readyNo) === 0;

  /* افزودن به سند */
  const addToDoc = async () => {
    if (!selectedRows.length) { setError('هیچ ردیفی انتخاب نشده است'); return; }
    if (isNewDoc && !docDate) { setError('برای ساخت سند جدید، تاریخ سند را وارد کنید'); return; }
    setSaving(true); setError('');
    const payload = {
      financial_year: si(toEng(String(year))),
      ready_document_no: si(readyNo),   // 0 = سند جدید
      doc_date: docDate,
      mode,
      bank_account_code: si(bankCode),
      bank_account_number: bankNo,
      rows: rows.map((r,i) => ({ ...r, selected: !!checked[i], selection2: !!sel2[i] })),
    };
    const j = await API('/auto-document/deposit/add/', { method:'POST', body: JSON.stringify(payload) });
    setSaving(false);
    if (j.ok) { showToast(j.msg); onAdded && onAdded(); load(); }
    else setError(j.msg);
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>

        {/* هدر */}
        <div style={s.hdr}>
          <div>
            <div style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>💰 سپرده — ثبت خودکار از پیمانکاران</div>
            <div style={{fontSize:'11px',color:'rgba(255,255,255,0.6)',marginTop:'2px'}}>
              سال مالی {toFa(year)}
            </div>
          </div>
          <button onClick={onClose} style={s.xBtn}>✕</button>
        </div>

        <div style={s.body}>
          {error && <div style={s.err}>⚠️ {error}</div>}

          {/* نوار تنظیمات بالا */}
          <div style={s.card}>
            <div style={{display:'flex',gap:'14px',flexWrap:'wrap',alignItems:'flex-end'}}>
              {/* بستانکاری / استرداد */}
              <div style={{display:'flex',gap:'8px'}}>
                {[['credit','بستانکاری سپرده'],['refund','استرداد سپرده']].map(([v,l])=>(
                  <label key={v} style={{display:'flex',alignItems:'center',gap:'5px',cursor:'pointer',
                    padding:'8px 14px',borderRadius:'8px',fontSize:'12px',fontWeight:'700',
                    background:mode===v?'#e8eaf6':'#f5f5f5',
                    border:`1.5px solid ${mode===v?'#7986cb':'#e0e0e0'}`,
                    color:mode===v?'#1a237e':'#666'}}>
                    <input type="radio" checked={mode===v} onChange={()=>setMode(v)}
                      style={{width:'14px',height:'14px'}}/>
                    {l}
                  </label>
                ))}
              </div>
              <div style={s.fld}>
                <label style={s.lbl}>از ماه</label>
                <input value={toFa(month)} onChange={e=>setMonth(toEng(e.target.value).replace(/\D/g,'').slice(0,2))}
                  style={{...s.inp,width:'60px'}} />
              </div>
              <button onClick={load} disabled={loading} style={s.btnS}>{loading?'⏳...':'↺ به‌روزرسانی'}</button>
            </div>
          </div>

          {/* سند مقصد */}
          <div style={{...s.card, background:'#fffdf5', border:'1.5px solid #f0e6c0'}}>
            <div style={{fontSize:'12px',fontWeight:'700',color:'#8d6e00',marginBottom:'8px'}}>🧾 سند مقصد</div>
            <div style={{display:'flex',gap:'14px',flexWrap:'wrap',alignItems:'flex-end'}}>
              <div style={s.fld}>
                <label style={s.lbl}>شماره سند مقصد</label>
                <input value={toFa(readyNo)}
                  onChange={e=>setReadyNo(toEng(e.target.value).replace(/\D/g,'').slice(0,6))}
                  placeholder="خالی = سند جدید"
                  style={{...s.inp,width:'150px'}} />
              </div>
              {isNewDoc && (
                <div style={s.fld}>
                  <label style={s.lbl}>تاریخ سند جدید *</label>
                  <JalaliDatePicker value={docDate} onChange={v=>setDocDate(v)} placeholder="انتخاب تاریخ"/>
                </div>
              )}
              <div style={{fontSize:'11px',color:'#8d6e00',flex:1,minWidth:'200px',lineHeight:'1.7'}}>
                {isNewDoc
                  ? '↩ شماره خالی است: یک سند جدید (نوع «هزینه‌ای») ساخته می‌شود و اقلام در آن ثبت می‌گردد.'
                  : `↩ اقلام به سند شماره ${toFa(readyNo)} همان سال مالی اضافه می‌شوند.`}
              </div>
            </div>
          </div>

          {mode==='credit' && (
            <div style={s.card}>
              <div style={{fontSize:'12px',fontWeight:'700',color:'#1a2f50',marginBottom:'8px'}}>🏦 حساب بانکی (ردیف تجمیعی — اختیاری)</div>
              <div style={{display:'flex',gap:'14px',flexWrap:'wrap'}}>
                <div style={s.fld}>
                  <label style={s.lbl}>کد حساب بانکی</label>
                  <input value={bankCode} onChange={e=>setBankCode(e.target.value)} style={{...s.inp,width:'110px'}} />
                </div>
                <div style={s.fld}>
                  <label style={s.lbl}>شماره حساب</label>
                  <input value={bankNo} onChange={e=>setBankNo(e.target.value)} style={{...s.inp,width:'170px'}} />
                </div>
              </div>
            </div>
          )}

          {/* جدول */}
          <div style={{flex:1,overflow:'auto',borderRadius:'8px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)'}}>
            <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl',fontSize:'11.5px',tableLayout:'fixed'}}>
              {/* سرستون‌ها */}
              <thead>
                <tr>
                  <TH idx={0}><span
                      onClick={()=>toggleAll(!(rows.length>0 && selectedRows.length===rows.length))}
                      title="انتخاب همه" style={{cursor:'pointer',fontWeight:'700'}}>
                      {rows.length>0 && selectedRows.length===rows.length ? '✓' : '▢'}</span></TH>
                  {mode==='credit' ? (<>
                    <TH idx={1}>شماره بستانکاری</TH>
                    <TH idx={2}>سال</TH>
                    <TH idx={3}>ردیف سپرده</TH>
                    <TH idx={4}>مبلغ سپرده</TH>
                    <TH idx={5}>شماره قبض</TH>
                    <TH idx={6} right>موضوع سپرده</TH>
                    <TH idx={7} right>قرارداد</TH>
                    <TH idx={8} right>پیمانکار</TH>
                  </>) : (<>
                    <TH idx={1}>شماره استرداد</TH>
                    <TH idx={2}>شماره/سال بستانکاری</TH>
                    <TH idx={3}>مبلغ سپرده</TH>
                    <TH idx={4}>استرداد قبلی</TH>
                    <TH idx={5}>مبلغ استرداد</TH>
                    <TH idx={6}>مانده سپرده</TH>
                    <TH idx={7}>ثبت پرداخت بانکی هم</TH>
                    <TH idx={8} right>قرارداد</TH>
                    <TH idx={9} right>پیمانکار</TH>
                  </>)}
                </tr>
              </thead>
              <tbody>
                {rows.map((r,i)=>(
                  <tr key={keyOf(r)} onClick={()=>setChecked(c=>({...c,[i]:!c[i]}))} style={{background:checked[i]?'#c8e6c9':i%2===0?'#fff':'#fafafa',cursor:'pointer'}}>
                    <td style={{...s.td,fontWeight:'700',color:checked[i]?'#1b5e20':'#bbb'}}>{checked[i]?'✓':''}</td>
                    {mode==='credit' ? (<>
                      <td style={s.td}>{toFa(r.credit_no)}</td>
                      <td style={s.td}>{toFa(r.credit_year)}</td>
                      <td style={s.td}>{toFa(r.detail_row)}</td>
                      <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#1b5e20'}}>{numFmt(r.detail_amount)}</td>
                      <td style={s.td}>{r.slip_no||'—'}</td>
                      <td style={{...s.td,textAlign:'right'}}>{r.deposit_subject||'—'}</td>
                    </>) : (<>
                      <td style={s.td}>{toFa(r.refund_no)}/{toFa(r.refund_year)}</td>
                      <td style={s.td}>{toFa(r.credit_no)}/{toFa(r.credit_year)}</td>
                      <td style={{...s.td,fontFamily:'monospace'}}>{numFmt(r.detail_amount)}</td>
                      <td style={{...s.td,fontFamily:'monospace',color:'#999'}}>{numFmt(r.prev_refund)}</td>
                      <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.refund_pay)}</td>
                      <td style={{...s.td,fontFamily:'monospace'}}>{numFmt(r.remaining)}</td>
                      <td style={s.td} onClick={e=>e.stopPropagation()}><input type="checkbox" checked={!!sel2[i]}
                        onChange={e=>setSel2(v=>({...v,[i]:e.target.checked}))} /></td>
                    </>)}
                    <td style={{...s.td,textAlign:'right',maxWidth:'180px',overflow:'hidden',
                      textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={r.contract_display}>
                      {r.contract_display||'—'}
                    </td>
                    <td style={{...s.td,textAlign:'right'}}>{r.contractor_name||'—'}</td>
                  </tr>
                ))}
                {!loading && rows.length===0 && (
                  <tr><td colSpan={11} style={{...s.td,padding:'24px',color:'#999'}}>📭 رکوردی یافت نشد</td></tr>
                )}
              </tbody>
            </table>
          </div>

          {/* فوتر جمع و دکمه */}
          <div style={{display:'flex',alignItems:'center',gap:'12px',flexWrap:'wrap'}}>
            <span style={s.badge('#1a2f50')}>{toFa(selectedRows.length)} ردیف انتخاب شده</span>
            <span style={s.badge(mode==='credit'?'#1b5e20':'#b71c1c')}>
              جمع مبلغ: {numFmt(totalAmount)}
            </span>
            <button onClick={addToDoc} disabled={saving || !selectedRows.length}
              style={{...s.btnP,marginRight:'auto',
                opacity:(saving||!selectedRows.length)?0.4:1}}>
              {saving?'⏳ در حال ثبت...':(isNewDoc?'💾 ساخت سند جدید و ثبت':'💾 افزودن به سند')}
            </button>
          </div>
        </div>

        {toast && (
          <div style={{position:'absolute',bottom:'14px',right:'14px',
            background:'#1b5e20',color:'#fff',padding:'10px 20px',
            borderRadius:'8px',fontSize:'13px',fontWeight:'600',zIndex:10}}>
            {toast}
          </div>
        )}
      </div>
    </div>
  );
}

/* استایل‌ها */
const s = {
  overlay:   {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,
               display:'flex',alignItems:'center',justifyContent:'center',padding:'12px'},
  modal:     {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'980px',
               maxHeight:'90vh',display:'flex',flexDirection:'column',
               boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden',position:'relative'},
  hdr:       {display:'flex',justifyContent:'space-between',alignItems:'flex-start',
               padding:'14px 18px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',flexShrink:0},
  xBtn:      {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',
               color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',
               fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:      {flex:1,overflowY:'auto',padding:'14px',display:'flex',flexDirection:'column',gap:'10px'},
  err:       {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'7px',
               padding:'8px 12px',color:'#c62828',fontSize:'12px'},
  card:      {background:'#fff',borderRadius:'10px',padding:'14px',
               boxShadow:'0 1px 4px rgba(0,0,0,0.08)'},
  fld:       {display:'flex',flexDirection:'column',gap:'3px'},
  lbl:       {fontSize:'11px',fontWeight:'600',color:'#555'},
  inp:       {padding:'7px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',
               fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
               direction:'rtl',textAlign:'right',boxSizing:'border-box'},
  th:        {padding:'7px 9px',fontSize:'10.5px',fontWeight:'700',textAlign:'center',
               whiteSpace:'nowrap',background:'#1a2f50',color:'#fff',position:'sticky',top:0},
  td:        {padding:'5px 8px',fontSize:'11px',textAlign:'center',
               borderBottom:'1px solid #f0f0f0',whiteSpace:'nowrap',
               overflow:'hidden',textOverflow:'ellipsis'},
  btnP:      {padding:'9px 20px',background:'linear-gradient(135deg,#8d6e00,#C8A84B)',
               color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',
               fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnS:      {padding:'8px 14px',background:'#e0e0e0',color:'#333',border:'none',
               borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px',alignSelf:'flex-end'},
  badge:     bg => ({padding:'5px 12px',background:bg,color:'#fff',
               borderRadius:'16px',fontSize:'12px',fontWeight:'700'}),
};